export default __webpack_public_path__ + "static/media/mobileHero.d866212b.png";